/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNavigationPageHeader = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-navigation-page-header_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-navigation-page-header_svg__st0" d="M17 11h2v2h-2zm-3 0h2v2h-2z" />
    <path className="ico-navigation-page-header_svg__st0" d="M2 7v10h20V7H2zm18 8H4V9h16v6z" />
    <path className="ico-navigation-page-header_svg__st0" d="M5 11h2v2H5z" />
  </Icon>
);
export { SvgNavigationPageHeader as NavigationPageHeader };
